import { Empty } from "antd";
import moment from "moment";
import { useTranslation } from "react-i18next";

export default function UploadHistoryList({
  handleSingleRcordDownload,
  dataSource = [],
  setDetails,
  setVisible,
}) {
  const { t } = useTranslation();
  return (
    <>
      {dataSource.length === 0 ? (
        <Empty
          description={t("pages.payment_history.no_history_found", {
            defaultValue: "No history found",
          })}
        />
      ) : (
        <div>
          <div style={{ cursor: "pointer" }}>
            {dataSource.map((option, idx) => (
              <div
                key={idx}
                onClick={() => {
                  setDetails(option);
                  setVisible(true);
                }}
                className="account-row-data list-row mb-2"
                style={{ cursor: "pointer" }}
              >
                <div className="list-row-display-item">
                  <div className="list-item-heading">
                    <span
                      className="pay-now-text"
                      style={{
                        textDecoration: "underline",
                        whiteSpace: "break-spaces",
                        wordBreak: "break-all",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        handleSingleRcordDownload(option);
                      }}
                    >
                      {option.file || "-"}
                    </span>
                  </div>
                </div>

                <div align="right">
                  <div className="list-item-heading">{option?.valueDate}</div>
                  <div className="list-item-heading">
                    {option?.status === "SUCCESS" ? (
                      <span className="success-text px-2 py-1">
                        {" "}
                        {t("common.success_cap", {
                          defaultValue: "SUCCESS",
                        })}
                      </span>
                    ) : (
                      <span className="fail-error px-2 py-1">
                        {option?.status}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
